<template>
<div class="user-wrapper">
  <div class="subpage__inner">
         <SubpageNav :links="links" class="DesktopTab"/>
    <div class="mobileTab" style="margin-top: 80px">
         <select-box :options="linkMobile" title="Hakkında"/>
    </div>
    <transition name="fade-up">
         <router-view/>
    </transition>
  </div>
</div>
</template>

<script>
import SubpageNav from '@/components/SubpageNav'
import SelectBox from '@/components/SelectBox'
//import axios from 'axios'
export default {
  name: 'DormUser',
  components: {
    SubpageNav, SelectBox
  },
  data () {
    return {
      links: [
        {
          id: 0,
          title: 'Hesap Bilgileri',
          to: { name: 'DormUserAccount' }
        },
        {
          id: 1,
          title: 'İstatistikler',
          to: { name: 'DormUserStatistic' }
        },
        {
          id: 2,
          title: 'Mesajlar',
          to: { name: 'DormUserMessages' }
        },
        {
          id: 3,
          title: 'Yurtlar',
          to: { name: 'DormUserDorms' }
        },
        {
          id: 4,
          title: 'Yorumlar',
          to: { name: 'DormUserComments' }
        }
      ],
      linkMobile: [
        {
          name: 'Hesap Bilgileri'
        },
        {
          name: 'İstatistikler'
        },
        {
          name: 'Mesajlar'
        },
        {
          name: 'Yurtlar'
        },
        {
          name: 'Yorumlar'
        }
      ]
    }
  }
}
</script>
<style lang="scss">
@import "../assets/scss/components/user";
</style>
